// src/components/FirmManager.jsx

import React, { useState } from 'react';
import { db } from '../config/firebase';
import {
  collection,
  addDoc,
  getDocs,
  query,
  where,
  updateDoc,
  deleteDoc,
  doc,
} from 'firebase/firestore';
import Modal from 'react-modal';
import { FaEdit, FaTrash } from 'react-icons/fa';
import '../css/FirmManager.css'; // Kreirajte ovaj CSS fajl za stilove

Modal.setAppElement('#root');

function FirmManager({ isOpen, onClose, firms, setFirms }) {
  const [newFirmName, setNewFirmName] = useState('');
  const [editedFirmName, setEditedFirmName] = useState('');
  const [currentFirm, setCurrentFirm] = useState(null);
  const firmsCollection = collection(db, 'firms');

  const handleAddFirm = async (e) => {
    e.preventDefault();
    if (newFirmName.trim() === '') {
      alert('Ime firme ne može biti prazno.');
      return;
    }

    try {
      // Provjera postoji li već firma s istim imenom
      const q = query(firmsCollection, where('name', '==', newFirmName.trim()));
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        alert('Firma s tim imenom već postoji.');
        return;
      }

      await addDoc(firmsCollection, {
        name: newFirmName.trim(),
        createdAt: new Date()
      });
      setNewFirmName('');
      alert('Firma uspješno dodana.');
    } catch (error) {
      console.error('Greška pri dodavanju firme:', error);
      alert('Došlo je do greške prilikom dodavanja firme.');
    }
  };

  const handleEditFirm = async (firm) => {
    setCurrentFirm(firm);
    setEditedFirmName(firm.name);
  };

  const handleSaveEdit = async () => {
    if (!currentFirm || editedFirmName.trim() === '') return;

    try {
      const firmDoc = doc(db, 'firms', currentFirm.id);
      await updateDoc(firmDoc, {
        name: editedFirmName.trim()
      });
      setCurrentFirm(null);
      setEditedFirmName('');
    } catch (error) {
      console.error('Greška pri ažuriranju firme:', error);
      alert('Došlo je do greške prilikom ažuriranja firme.');
    }
  };

  const handleDeleteFirm = async (firm) => {
    if (firm.id === 'default') {
      alert('Zadana firma ne može biti izbrisana.');
      return;
    }

    if (!window.confirm(`Jeste li sigurni da želite izbrisati firmu "${firm.name}"?`)) {
      return;
    }

    try {
      await deleteDoc(doc(db, 'firms', firm.id));
      alert('Firma uspješno izbrisana.');
    } catch (error) {
      console.error('Greška pri brisanju firme:', error);
      alert('Došlo je do greške prilikom brisanja firme.');
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="firm-manager-container"
      overlayClassName="overlay"
    >
      <div className="modal-header">
        <h2>Upravljanje Firmama</h2>
        <button onClick={onClose} className="close-modal-button">&times;</button>
      </div>

      <div className="add-firm-section">
        <input
          type="text"
          value={newFirmName}
          onChange={(e) => setNewFirmName(e.target.value)}
          placeholder="Unesite naziv nove firme"
        />
        <button onClick={handleAddFirm} className="add-firm-button">
          Dodaj Firmu
        </button>
      </div>

      <table>
        <thead>
          <tr>
            <th>Naziv Firme</th>
            <th style={{ width: '120px' }}>Akcije</th>
          </tr>
        </thead>
        <tbody>
          {firms
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((firm) => (
              <tr key={firm.id} className={firm.id === 'default' ? 'default-row' : ''}>
                <td>
                  {currentFirm?.id === firm.id ? (
                    <input
                      type="text"
                      value={editedFirmName}
                      onChange={(e) => setEditedFirmName(e.target.value)}
                      onBlur={handleSaveEdit}
                      autoFocus
                    />
                  ) : (
                    firm.name
                  )}
                </td>
                <td>
                  {firm.id !== 'default' ? (
                    <div className="action-buttons">
                      <button
                        className="edit-button"
                        title="Uredi firmu"
                        onClick={() => handleEditFirm(firm)}
                      >
                        <FaEdit />
                      </button>
                      <button
                        className="delete-button"
                        title="Izbriši firmu"
                        onClick={() => handleDeleteFirm(firm)}
                      >
                        <FaTrash />
                      </button>
                    </div>
                  ) : (
                    <span className="na-text">N/A</span>
                  )}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </Modal>
  );
}

export default FirmManager;